module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "safari-pinned-tab.85b648bd.svg";